import {
  FETCH_USER_PROFILE,
  CHANGE_PROFILE_FIELD,
} from "../actions/actionTypes";

const initialState = {
  profile: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_USER_PROFILE:
      return { ...state, profile: payload };

    case CHANGE_PROFILE_FIELD:
      const newProfle = state.profile;
      newProfle[payload.field] = payload.value;
      return { ...state, profile: newProfle };

    case "SET_REQUESTS_NOTIFICATIONS":
      return { ...state, hasRequestsNotifications: payload };

    case "TURN_OFF_R_NOTIFICATIONS":
      return { ...state, hasRequestsNotifications: false };
    default:
      return state;
  }
};
